import SectionHeading from './SectionHeading';

const quotes = [
  {
    name: '品牌商务 李女士',
    role: '合作品牌方',
    text: '以前遇到坑位费纠纷只能吃哑巴亏。这里的合同照片和转账记录能逐笔对上，沟通时终于有了可以摊开讲的依据。',
  },
  {
    name: '内容从业者 阿哲',
    role: '短视频创作者',
    text: '分成比例的争议最怕口说无凭。站点把录音关键时间点标出来，比单纯看一段爆料文字清楚太多。',
  },
  {
    name: '长期读者 周同学',
    role: '关注者',
    text: '会标"待回应"而不是直接下结论，这一点让我愿意持续看。至少能看到材料，而不是只有情绪。',
  },
];

export default function Testimonials() {
  return (
    <section className="py-12 md:py-16">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHeading eyebrow="Reader Voices" title="读者与合作方怎么看" />
        <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
          {quotes.map((q) => (
            <figure key={q.name} className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5">
              <i className="ri-double-quotes-l text-2xl text-accent-500"></i>
              <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">{q.text}</blockquote>
              <figcaption className="mt-4 border-t border-background-200 pt-4">
                <span className="block text-sm font-medium text-foreground-900">{q.name}</span>
                <span className="block text-xs text-foreground-500">{q.role}</span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}